{
	"title": "Erklæringer",
	"table": {
		"material": "Materiale",
		"dateOfIssue": "Utstedelsesdato",
		"quantity": "Mengde",
		"carbonSavings": "Karbonreduksjoner",
		"status": {
			"title": "Status",
			"TransactionProcessing": "Transaksjonsbehandling",
			"CreatingDeclaration": "Opprette erklæring",
			"GenerationFailed": "Generasjon mislyktes",
			"ReadyToDownload": "Klar til nedlasting"
		}
	},
	"declarationLanguageSelect": {
		"title": "Erklæringsspråk",
		"description": "Velg et deklarasjonsspråk.",
		"label": "Erklæringsspråk",
		"buttonBack": "Tilbake",
		"buttonSave": "Lagre"
	},
	"downloadAllLanguageSelect": {
		"title": "Deklarasjonsspråk",
		"descriptionGlobal": "Velg et språk for alle deklarasjoner.",
		"descriptionIndividual": "Eller angi språket for hver erklæring individuelt.",
		"label": "Deklarasjonsspråk",
		"tableHeaderDeclaration": "Erklæring (materiale/utstedelsesdato)",
		"tableHeaderLanguage": "Erklæringsspråk",
		"buttonBack": "Tilbake",
		"buttonDownload": "Last ned erklæringer"
	},
	"declarationActions": {
		"changeLanguage": "Endre deklarasjonsspråk",
		"preview": "Forhåndsvisning",
		"download": "Last ned",
		"transaction": "Transaksjon",
		"showMoreTransactions": "Vis flere transaksjoner",
		"languageLabel": "Erklæringsspråk",
		"downloadAll": "Last ned alle erklæringer"
	}
}
